import { render, staticRenderFns } from "./BannerVideo.vue?vue&type=template&id=60875dbc&scoped=true&"
import script from "./BannerVideo.vue?vue&type=script&lang=js&"
export * from "./BannerVideo.vue?vue&type=script&lang=js&"
import style0 from "./BannerVideo.vue?vue&type=style&index=0&id=60875dbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60875dbc",
  null
  
)

export default component.exports